import {
  get
  // remove,
  // clear
} from '../utils/token'
import { filterRoute } from '../utils/auth'
import Store from '../store/index'
export function getExerlandRouter (routerAuth) {
  const { exerlandRouter, tabbarRouter } = filterRoute(routerAuth)
  return [
    {
      path: '/exerland',
      name: 'Exerland',
      component: () =>
        import('../views/exerland/Index.vue'),
      redirect: () => {
        if (dd.env.platform !== 'notInDingTalk') {
          // remove('user')
          // clear()
        }
        // clear()
        return '/exerland/bbs'
      },
      children: [
        {
          path: 'bbs',
          name: 'Bbs',
          component: () =>
            import('../views/exerland/exerland.vue'),
          redirect: () => {
            const tabindex = get('tabIndex')
            const power = Store.getters['tarbarAuth/getAuth']
            let path = 'find'
            switch (tabindex) {
              case 'bbs':
                path = 'communication'
                break
              case 'live':
                path = 'liveList'
                break
              case 'center':
                path = 'center'
                break
              case 'refining':
                path = 'refining'
                break
              case 'groupsList':
                path = 'groupsList'
                break
              default:
                if (power.home) {
                  path = 'find'
                } else if (power.dynamic) {
                  path = 'dynamic'
                } else if (power.refining) {
                  path = 'refining'
                } else if (power.center) {
                  path = 'center'
                } else if (power.groupsList) {
                  path = 'groupsList'
                } else {
                  path = 'find'
                }
            }
            return `/exerland/bbs/${path}`
          },
          children: tabbarRouter
        },
        {
          path: 'luckDraw',
          name: 'LuckDraw',
          component: () =>
            import(
              '../views/exerland/center/luckDraw.vue'
            )
        },
        ...exerlandRouter
      ]
    },
    {
      path: '*',
      name: '404',
      component: () => import('../views/noValidation/404.vue')
    }
  ]
}
